import React from 'react';
import { observer } from 'mobx-react';

import { routerStore } from 'core/routing';
import { ListField } from 'libs/forms/views/fieldTypes/list';
import { Dropdown } from 'apps/autocomplete/views/dropdown';

import { Center } from 'legacyComponents/styled/lib';
import { SectionTitle, ButtonStyled } from 'apps/group/styles';
import { GroupMember } from 'apps/group/views/groupMember';
import { GroupInvite } from 'apps/group/views/groupInvite';
import { FormField } from 'libs/forms/styles';

import Banner from 'components/Banner';

import {
  Main,
  Invite,
  InvWrapper,
  NoMembers,
} from 'apps/group/views/groupSection.styles';

export const GroupSection = observer(({ group, project }) => {
  const { members, InviteMembers, pendingInvites } = group;

  const displayName = `${group.name.charAt(0).toUpperCase() +
    group.name.slice(1)}s`;

  const membersList =
    Array.isArray(members) && members.length === 0 ? (
      <div>
        <NoMembers>(There are currently no confirmed {displayName})</NoMembers>
      </div>
    ) : (
      members.map(member => (
        <GroupMember
          member={member}
          group={group}
          groupDispName={displayName}
          key={member.id}
        />
      ))
    );

  const invitesList =
    Array.isArray(pendingInvites) &&
    pendingInvites.map(invite => (
      <GroupInvite
        invite={invite}
        group={group}
        groupDispName={displayName}
        key={invite.id}
      />
    ));

  const fieldStore = group.membersForm.fieldStores.get('newMembers');
  let button = '';
  if (group.newMembers.length !== 0) {
    let value = 'Send Invitation';
    if (group.newMembers.length > 1) {
      value = 'Send Invitations';
    }
    if (group.membersForm.posting) {
      value = 'Sending...';
    }
    button = (
      <Center>
        <ButtonStyled
          text={value}
          size='small'
          onMouseDown={() => InviteMembers()}
          outline
        />
      </Center>
    );
  }

  const refs = {};
  return (
    <Main>
      <SectionTitle level={2} size='medium'>
        {displayName}:
      </SectionTitle>
      {group.canAddMember && (
        <InvWrapper>
          <FormField>
            <Invite>{`Invite ${displayName}`}</Invite>
            <ListField
              ref={input => {
                refs.newMembers = input;
              }}
              fieldStore={fieldStore}
              noValidationIcon
              responsive
            />
            <Dropdown
              inputFields={refs}
              fieldName='newMembers'
              manager={fieldStore.optionsManager}
            />
          </FormField>
          {button}
          {routerStore.route.name.includes('project') &&
          project &&
          project.isPrivate ? (
            <Banner variant='warning'>
              Note: inviting collaborators to private projects may incur
              additional charges.
            </Banner>
          ) : null}
        </InvWrapper>
      )}
      {membersList}
      {invitesList}
    </Main>
  );
});
